(function () {
  'use strict';

  function init() {
    var stage = document.querySelector('[data-us-catmq]:not([data-us-catmq-wired])');
    var P = window.US_PANEL;
    if (!stage || !P || !P.categories || !P.categories.length) return;
    stage.setAttribute('data-us-catmq-wired', '');
    var ICONS = window.US_CATEGORY_ICONS;
    var link = stage.getAttribute('data-link');

    function icon(name) {
      return ICONS && ICONS.build ? ICONS.build(name, null) : null;
    }

    function chip(cat) {
      var el = document.createElement(link ? 'a' : 'div');
      el.className = 'us-catmq__chip';
      if (link) el.href = link;
      var tile = document.createElement('span');
      tile.className = 'us-catmq__tile';
      tile.style.setProperty('--cat', cat.color || 'var(--us-fern)');
      var ic = icon(cat.name);
      if (ic) tile.appendChild(ic);
      var label = document.createElement('span');
      label.className = 'us-catmq__label';
      label.textContent = cat.name;
      el.appendChild(tile);
      el.appendChild(label);
      return el;
    }

    function group(cats, hidden) {
      var g = document.createElement('div');
      g.className = 'us-catmq__group';
      if (hidden) g.setAttribute('aria-hidden', 'true');
      cats.forEach(function (c) { g.appendChild(chip(c)); });
      return g;
    }

    var cats = P.categories;
    var mid = Math.ceil(cats.length / 2);
    [cats.slice(0, mid), cats.slice(mid)].forEach(function (rowCats, i) {
      if (!rowCats.length) return;
      var row = document.createElement('div');
      row.className = 'us-catmq__row';
      var track = document.createElement('div');
      track.className = 'us-catmq__track' + (i % 2 ? ' us-catmq__track--rev' : '');
      track.appendChild(group(rowCats, false));
      track.appendChild(group(rowCats, true));
      row.appendChild(track);
      stage.appendChild(row);
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stage.classList.toggle('is-offscreen', !entry.isIntersecting);
        });
      }, { rootMargin: '100px 0px' });
      io.observe(stage);
    }
  }

  if (document.readyState === 'complete') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
